module.exports = __webpack_public_path__ + "static/media/event-services-img40.9426d65c.jpg";